import { TrainingQuestionPublic } from '../../services/trainingApi';

interface QuestionCardProps {
  index: number;
  total: number;
  pregunta: TrainingQuestionPublic;
  seleccion?: 'a' | 'b' | 'c' | 'd';
  onSelect: (opcion: 'a' | 'b' | 'c' | 'd') => void;
  disabled?: boolean;
}

export default function QuestionCard({
  index,
  total,
  pregunta,
  seleccion,
  onSelect,
  disabled = false,
}: QuestionCardProps) {
  return (
    <div className="rounded-xl border border-ngs-cyan/20 bg-ngs-surface p-6">
      <div className="flex items-center justify-between mb-4">
        <span className="text-xs text-ngs-cyan font-semibold tracking-wider">
          PREGUNTA {index + 1} / {total}
        </span>
      </div>

      <h3 className="text-lg text-white font-medium mb-5 leading-relaxed">
        {pregunta.pregunta}
      </h3>

      <div className="space-y-2">
        {pregunta.opciones.map((opt) => {
          const activa = seleccion === opt.id;
          return (
            <button
              key={opt.id}
              type="button"
              onClick={() => !disabled && onSelect(opt.id)}
              disabled={disabled}
              className={`w-full text-left rounded-lg border p-4 transition-all ${
                activa
                  ? 'border-ngs-cyan bg-ngs-cyan/15 text-white'
                  : 'border-gray-700 bg-ngs-bg hover:border-ngs-cyan/40 text-gray-300'
              } ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}`}
            >
              <span className="inline-flex items-center justify-center h-7 w-7 rounded-full border border-current mr-3 text-xs font-bold uppercase">
                {opt.id}
              </span>
              {opt.texto}
            </button>
          );
        })}
      </div>
    </div>
  );
}
